import { render } from "./LightBox.vue?vue&type=template&id=0a31983b&ts=true"
import script from "./LightBox.vue?vue&type=script&lang=ts"
export * from "./LightBox.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__